import Modal from '@/shared/Modal'
import FormField from '@/shared/Forms/FormField'
import TextInput from '@/shared/Inputs/TextInput'
import Button from '@/shared/Buttons/Button'
import useHttpLoader from '@/shared/hooks/useHttpLoader.ts'
import useStateWithChange from '@/shared/hooks/useStateWithChange.ts'
import { useEffect } from 'react'
import SeparateLine from '@/shared/Forms/SeparateLine'
import { IDashboardGroup, TCreateDashboardDTO } from '@/pages/Dashboards/dashboards.types.ts'
import dashboardsApi from '@/pages/Dashboards/dashboards.api.ts'
import dashboardsEvents from '@/pages/Dashboards/events/dashboards.events.ts'
import Toggle from '@/shared/Inputs/Toggle'

interface IProps {
  groupId?: IDashboardGroup['id']
  open: boolean
  onClose: () => void
}

const CreateDashboardModal = (props: IProps) => {
  const { wait, loading } = useHttpLoader()
  const [dashboard, setDashboard, handleChange] = useStateWithChange<TCreateDashboardDTO>({
    name: '',
    groupId: props.groupId,
    sharedWithOrganization: false,
  })

  useEffect(() => {
    setDashboard({
      name: '',
      groupId: props.groupId,
      sharedWithOrganization: false,
    })
  }, [props.groupId])

  const handleSave = () => {
    wait(dashboardsApi.createDashboard(dashboard), (resp) => {
      if (resp.status === 'success') {
        dashboardsEvents.created(resp.body)
        props.onClose()
      }
    })
  }

  return (
    <Modal title="Создание дашборда" onClose={props.onClose} open={props.open} closeOnClickOutside={false}>
      <div className="flex-lines gap16">
        <FormField label="Наименование дашборда" required>
          <TextInput name="name" onChange={handleChange} value={dashboard.name} placeHolder="Введите наименование" />
        </FormField>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Toggle
            name="sharedWithOrganization"
            checked={dashboard.sharedWithOrganization}
            onChange={handleChange}
            size="large"
          />
          <p className="text-nm">Виден всем сотрудникам организации</p>
        </div>
        <p className="text-nm text-warning">
          {dashboard.sharedWithOrganization ? 'Дашборд виден всем сотрудникам организации' : 'Дашборд виден только вам'}
        </p>
        <SeparateLine />
        <div className="inline-flex-gap gap8">
          <Button size="default" type="default" text="Отмена" onClick={props.onClose} disabled={loading} />
          <Button size="default" type="primary" text="Создать" onClick={handleSave} loading={loading} />
        </div>
      </div>
    </Modal>
  )
}

export default CreateDashboardModal
